import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { ReviewSystem } from './components/ReviewSystem';
import { Volumes } from './components/Volumes';
import { Extras } from './components/Extras';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="28sur4e8bzhhi">
      <MetaPixel data-id="element-1" data-mp="23u9tmmkgrbwr" />
      <Hero data-id="element-2" data-mp="23utcq6luo6cd" />
      <main data-id="element-3" data-mp="23v2tr4ox335x">
        <BeforeAfter data-id="element-4" data-mp="23ti8k5ohswkq" />
        <ReviewSystem data-id="element-5" data-mp="3ik7eyd5x05p2" />
        <Volumes data-id="element-6" data-mp="3iiwdijzxza14" />
        <Extras data-id="element-7" data-mp="3ijfwm41bw4gq" />
        <Bonuses data-id="element-8" data-mp="3ijpef4c7z5bc" />
        <Offer data-id="element-9" data-mp="3ii4ppvcl6gle" />
        <Guarantee data-id="element-10" data-mp="3mlaxj7fckftz" />
        <Testimonials data-id="element-11" data-mp="3mkrgru1fnxhj" />
        <Author data-id="element-12" data-mp="3mjzuj9tq7c3x" />
        <Faq data-id="element-13" data-mp="3mjga9mglsbmq" />
        <FinalCta data-id="element-14" data-mp="3mj6lu3b7icj5" />
      </main>
      <Footer data-id="element-15" data-mp="3rbzmaezn6ypf" />
      <FloatingCta data-id="element-16" data-mp="3rdatypw7kqlt" />
      <PurchasePopup data-id="element-17" data-mp="3rd1azm9kzjpm" />
    </div>;
}